// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3wwRB","tab":"ProcedureTabs_tab__1EqTa"};